// extracted by mini-css-extract-plugin
module.exports = {"full-background-image":"full-background-image-m__full-background-image__1eSnp","full-background-image__content":"full-background-image-m__full-background-image__content__UaPZ3"};